// extracted by mini-css-extract-plugin
module.exports = {"container":"otp_container__1jjen","otp-input":"otp_otp-input__1IXgV"};